import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'status',
  pure: false
})
export class StatusPipe implements PipeTransform {

  transform(status: string): string {
    if (status === 'N?o autorizado') {
      status = 'Não autorizado';
    }

    return status;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/status.pipe.ts